export default __webpack_public_path__ + "static/media/iron_rod.30fc1115.png";